import { render, staticRenderFns } from "./collectionOfGeneralCallInformation.vue?vue&type=template&id=673b64b3&scoped=true&"
import script from "./collectionOfGeneralCallInformation.vue?vue&type=script&lang=js&"
export * from "./collectionOfGeneralCallInformation.vue?vue&type=script&lang=js&"
import style0 from "./collectionOfGeneralCallInformation.vue?vue&type=style&index=0&id=673b64b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b64b3",
  null
  
)

export default component.exports